import { Executor, ExecutorType } from '@40seas/entities/common';

interface ICurrencyFormatter {
    value?: number;
    currency?: string;
    options?: Intl.NumberFormatOptions;
    locale?: string;
}

export const formatAmount = ({ value, currency = 'USD', options, locale = undefined }: ICurrencyFormatter) => {
    const isCNH = currency === 'CNH';

    return value?.toLocaleString(locale, {
        style: 'currency',
        currency: isCNH ? 'CNY' : currency ?? 'USD',
        currencyDisplay: isCNH ? 'narrowSymbol' : 'symbol',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        ...options,
    });
};

interface IDateFormatter {
    value: Date;
    options?: Intl.DateTimeFormatOptions;
    locale?: string;
}

export const formatDate = ({ value, options, locale }: IDateFormatter) => {
    return value.toLocaleString(locale, {
        month: options?.month || 'short',
        day: options?.day || 'numeric',
        year: options?.year || 'numeric',
        timeZone: options?.timeZone || 'UTC',
        ...options,
    });
};

export const formatExecutor = (executor: Executor) => {
    if (executor.type === ExecutorType.User) {
        if (typeof executor.user !== 'string' && (executor.user?.name || executor.user?.email)) {
            return `${executor.type} ${executor.user.name || executor.user.email}`;
        }

        return `${executor.type} ${executor.id}`;
    }

    if (executor.type === ExecutorType.System) {
        return `${executor.type}`;
    }

    return `${executor.type} ${executor.id}`;
};

export const formatWalletAddress = (walletAddress?: string) => {
    if (!walletAddress) return '';
    // Standard EVM address display: 0x + first 4 chars ... last 4 chars
    // 0x1234...5678
    return `${walletAddress.slice(0, 6)}...${walletAddress.slice(-4)}`;
};
